import { Phone, MessageCircle } from "lucide-react";
import { buildTelLink, buildWhatsAppLink } from "@/features/driver/lib/driverPresentation.js";
import { useDriverLanguage } from "@/features/driver/i18n/useDriverLanguage";

interface ContactButtonsProps {
  phone?: string | null;
  whatsappMessage?: string;
}

/**
 * Call and WhatsApp deep-link buttons for contacting the customer. Links are
 * produced by tested pure helpers; buttons are disabled when no number exists.
 */
export default function ContactButtons({ phone, whatsappMessage }: ContactButtonsProps) {
  const { t } = useDriverLanguage();
  const telLink = buildTelLink(phone);
  const waLink = buildWhatsAppLink(phone, whatsappMessage ?? "Hi, this is your Europcar delivery driver. I have arrived.");

  const baseClass = "inline-flex h-12 flex-1 items-center justify-center rounded-md border px-4 text-sm font-medium transition-colors";

  return (
    <div className="flex gap-3">
      {telLink ? (
        <a href={telLink} className={`${baseClass} cursor-pointer border-neutral-300 bg-white hover:bg-neutral-50`}>
          <Phone className="mr-2 h-4 w-4" aria-hidden="true" /> {t("callBtn")}
        </a>
      ) : (
        <span className={`${baseClass} cursor-not-allowed border-neutral-200 bg-neutral-100 text-neutral-400`} aria-disabled="true">
          <Phone className="mr-2 h-4 w-4" aria-hidden="true" /> {t("callBtn")}
        </span>
      )}

      {waLink ? (
        <a href={waLink} target="_blank" rel="noopener noreferrer" className={`${baseClass} cursor-pointer border-green-300 bg-green-50 text-green-800 hover:bg-green-100`}>
          <MessageCircle className="mr-2 h-4 w-4" aria-hidden="true" /> {t("whatsappBtn")}
        </a>
      ) : (
        <span className={`${baseClass} cursor-not-allowed border-neutral-200 bg-neutral-100 text-neutral-400`} aria-disabled="true">
          <MessageCircle className="mr-2 h-4 w-4" aria-hidden="true" /> {t("whatsappBtn")}
        </span>
      )}
    </div>
  );
}
